<script lang="ts">
  /**
   * TimelineOverlay — vertical timeline of recent events.
   * Fetches from the engine's event graph via Tauri.
   */
  import { getTimeline } from "$lib/api/invoke";
  import type { TimelineEntry } from "$lib/api/invoke";

  let entries: TimelineEntry[] = $state([]);
  let loading = $state(true);

  async function load(): Promise<void> {
    try {
      entries = await getTimeline();
    } catch {
      entries = [];
    }
    loading = false;
  }

  load();
</script>

<div class="timeline-overlay">
  <h2 class="timeline-overlay__title">TIMELINE (T)</h2>

  <div class="timeline-overlay__border">+{"=".repeat(44)}+</div>

  <div class="timeline-overlay__list">
    {#if loading}
      <span class="timeline-overlay__empty">Loading...</span>
    {:else if entries.length === 0}
      <span class="timeline-overlay__empty">No events recorded yet.</span>
    {:else}
      {#each entries as entry}
        <div class="timeline-overlay__entry">
          <span class="timeline-overlay__time">{entry.time}</span>
          <span class="timeline-overlay__sep"> -- </span>
          <span class="timeline-overlay__text">{entry.text}</span>
        </div>
      {/each}
    {/if}
  </div>

  <div class="timeline-overlay__border">+{"=".repeat(44)}+</div>
</div>

<style>
  .timeline-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    max-height: 70vh;
  }

  .timeline-overlay__title {
    color: var(--fg-bright);
    font-size: 1.1rem;
    letter-spacing: 0.15em;
  }

  .timeline-overlay__border {
    color: var(--fg-dim);
    font-size: 0.85rem;
  }

  .timeline-overlay__list {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    overflow-y: auto;
    width: 100%;
    max-width: 50ch;
  }

  .timeline-overlay__entry {
    display: flex;
    flex-wrap: wrap;
    font-size: 0.85rem;
    line-height: 1.4;
  }

  .timeline-overlay__time {
    color: var(--fg-dim);
    white-space: nowrap;
  }

  .timeline-overlay__sep {
    color: var(--fg-dim);
  }

  .timeline-overlay__text {
    color: var(--fg);
  }

  .timeline-overlay__empty {
    color: var(--fg-dim);
    font-size: 0.85rem;
    text-align: center;
    padding: 1rem;
  }
</style>
